export interface ListParameter<T = number> {
    list: T[]
}